export default "__VITE_ASSET__BjtF3$YF__"